// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1yQO7","card__icon":"Card_card__icon__1Wlq_","card__container":"Card_card__container__BoPvU"};